import { Typography } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'

const { Text: AntText } = Typography

const Text = ({
  children,
  type,
  level,
  strong,
  bold,
  semi,
  medium,
  italic,
  underline,
  disabled,
  className,
  style,
  color,
  ...rest
}) => {
  const getTextSize = () => {
    switch (level) {
      case 1:
        return { fontSize: '24px' }
      case 2:
        return { fontSize: '20px' }
      case 3:
        return { fontSize: '16px' }
      case 4:
        return { fontSize: '14px' }
      default:
        return { fontSize: '14px' }
    }
  }
  const getTextWeight = () => {
    if (bold) return { fontWeight: 700 }
    if (semi) return { fontWeight: 600 }
    if (medium) return { fontWeight: 500 }
    return { fontWeight: 400 }
  }

  const getTextColor = () => {
    if (type === 'primary') return '#56B9C3'
    else if (type === 'secondary') return '#666'
    else if (color) {
      return color
    }
    return undefined
  }

  return (
    <AntText
      type={type}
      strong={strong}
      italic={italic}
      underline={underline}
      disabled={disabled}
      className={className}
      style={{
        ...getTextSize(),
        ...getTextWeight(),
        color: getTextColor(),
        ...style,
      }}
      {...rest}
    >
      {children}
    </AntText>
  )
}

Text.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'warning',
    'danger',
  ]),
  color: PropTypes.string,
  level: PropTypes.oneOf([1, 2, 3, 4]),
  bold: PropTypes.bool,
  semi: PropTypes.bool,
  medium: PropTypes.bool,
  strong: PropTypes.bool,
  italic: PropTypes.bool,
  underline: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}

Text.defaultProps = {
  level: 4,
  strong: false,
  bold: false,
  semi: false,
  medium: false,
  italic: false,
  underline: false,
  disabled: false,
}

export default Text
